import React from "react"

import { getSecondaryButtonStyles } from "./shared/button-styles"
import type { ViewMode } from "./types"

interface EntryModeSelectionProps {
  onSelectMode: (mode: ViewMode) => void
  onCancel: () => void
  canEdit?: boolean
}

export const EntryModeSelection: React.FC<EntryModeSelectionProps> = ({
  onSelectMode,
  onCancel,
  canEdit = true,
}) => {
  return (
    <div className="w-full">
      <h3
        className="text-base font-bold leading-[22px] tracking-[0.75px] capitalize text-[var(--blue-dark)]"
        style={{ marginBottom: `24px`, fontSize: `18px` }}
      >
        Choose Entry Method
      </h3>

      <div className="mb-6 grid grid-cols-2 gap-4">
        <button
          onClick={() => canEdit && onSelectMode(`annualForm`)}
          disabled={!canEdit}
          className="rounded-lg border border-gray-300 bg-gray-50 p-5 text-left transition-all hover:border-blue-500 hover:bg-blue-50"
          style={{ minHeight: `100px` }}
        >
          <h3
            className="mb-1 text-base font-semibold"
            style={{ color: `var(--blue-dark)` }}
          >
            Annual Usage
          </h3>
          <p className="text-sm text-gray-600">
            Enter total yearly kWh consumption
          </p>
        </button>

        <button
          onClick={() => canEdit && onSelectMode(`billForm`)}
          disabled={!canEdit}
          className="rounded-lg border border-gray-300 bg-gray-50 p-5 text-left transition-all hover:border-blue-500 hover:bg-blue-50"
          style={{ minHeight: `100px` }}
        >
          <h3
            className="mb-1 text-base font-semibold"
            style={{ color: `var(--blue-dark)` }}
          >
            Start from a Bill
          </h3>
          <p className="text-sm text-gray-600">
            Enter bill dates and amount to estimate the year
          </p>
        </button>
      </div>

      <div className="flex justify-center">
        <button
          type="button"
          onClick={onCancel}
          style={getSecondaryButtonStyles()}
        >
          Cancel
        </button>
      </div>
    </div>
  )
}
